import React from 'react';
import { VisibilityOutlined } from '@material-ui/icons';
import { useOperators } from '../../../hooks/useOperators';
import { useRDPs } from '../../../hooks/useRDPs';
import { usePanelView } from '../../PanelView';
import { APP_VIEW_ICONS, useAppView } from '../../../contexts/AppViewContext';
import { AppViewHeader } from './AppViewHeader';
import { AppViewOption } from './AppViewOption';

export const AppViewOptions = ({ onClose }: { onClose(): void }) => {
  const operators = useOperators();
  const rdps = useRDPs();

  const { setActivePanel } = usePanelView();
  const appView = useAppView();

  const handleNDPSelection = () => {
    appView.changePendingView({ id: 'NDP', code: 'NDP', type: 'NDP' }, true);
    onClose();
  };

  const handleRDPSelection = () => {
    if (rdps.data.length === 1) {
      const rdp = rdps.data[0];
      appView.changePendingView(
        {
          id: rdp.code,
          code: rdp.code,
          sector: rdp.type,
          type: 'RDP',
        },
        true
      );
      onClose();
    } else {
      appView.changePendingView({ type: 'RDP' });
      setActivePanel('Options');
    }
  };

  const handleOperatorSelection = () => {
    if (operators.data.length === 1) {
      const operator = operators.data[0];
      appView.changePendingView({
        id: operator.id.toString(),
        code: operator.code,
        sector: operator.type,
        type: 'Operator',
      });
      onClose();
    } else {
      appView.changePendingView({ type: 'Operator' });
      setActivePanel('Options');
    }
  };

  return (
    <React.Fragment>
      <AppViewHeader>
        <p className="inline-flex items-center flex-1 gap-3 font-bold">
          <VisibilityOutlined fontSize="small" />
          Application View
        </p>
      </AppViewHeader>
      <ul className="w-full bg-background-dark text-white p-2 space-y-2">
        {appView.permissions.canViewNDP && (
          <AppViewOption
            onClick={handleNDPSelection}
            selected={appView.type === 'NDP'}
          >
            <span className="inline-flex items-center gap-3">
              {APP_VIEW_ICONS('small').NDP} National
            </span>
          </AppViewOption>
        )}

        {appView.permissions.canViewRDP && rdps.data.length > 0 && (
          <AppViewOption
            onClick={handleRDPSelection}
            selected={appView.type === 'RDP'}
          >
            <span className="inline-flex items-center gap-3">
              {APP_VIEW_ICONS('small').RDP}
              {rdps.data.length > 1 && 'Regional'}
              {rdps.data.length === 1 && rdps.data[0].name}
            </span>
          </AppViewOption>
        )}

        {operators.data.length > 0 && (
          <AppViewOption
            onClick={handleOperatorSelection}
            selected={appView.type === 'Operator'}
          >
            <span className="inline-flex items-center gap-3">
              {APP_VIEW_ICONS('small').Operator}
              {operators.data.length > 1 && 'Operator'}
              {operators.data.length === 1 && operators.data[0].name}
            </span>
          </AppViewOption>
        )}
      </ul>
    </React.Fragment>
  );
};
